export const errorToastStyle = {
  position: "top-right",
  autoClose: 3000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
  theme: "dark",
  style: {
    background: "linear-gradient(to right, #8B0000, #800000, #B22222)",
    color: "#FFD700",
    fontFamily: "fantasy",
    fontSize: "18px",
    borderRadius: "10px",
    boxShadow: "0 4px 8px rgba(139,0,0,0.5)",
    border: "2px solid #FF0000",
    textTransform: "uppercase",
  },
};

export const infoToastStyle = {
  position: "top-right",
  autoClose: 2000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
  theme: "colored",
  style: {
    background: "linear-gradient(to right, #2C5364, #203A43, #0F2027)",
    color: "#ffffff",
    fontFamily: "fantasy",
    fontSize: "16px",
    borderRadius: "10px",
    boxShadow: "0 4px 8px rgba(0,0,0,0.3)",
    border: "2px solid #2C5364",
  },
};

export const successToastStyle = {
  position: "top-right",
  autoClose: 2000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
  theme: "colored",
  style: {
    background: "linear-gradient(to right, #008000, #008000, #004000)",
    color: "#ffffff",
    fontFamily: "fantasy",
    fontSize: "16px",
    borderRadius: "10px",
    boxShadow: "0 6px 12px rgba(0,255,0,0.3)",
    border: "2px solid #00ff00",
    textTransform: "uppercase",
    fontWeight: "bold",
    letterSpacing: "1px",
  },
};
